<template>
  <el-dialog id="popup_dialog" :title="titlu" :visible.sync="showPopup" class="my-dialog-class custom-width">
    <div class="container">
      <el-form label-position="top" :inline="false" :rules="rules" label-width="100%" :model="selectedObject"
        ref="my-form" @submit.prevent="save" v-loading="loadingVisible">
        <el-row :gutter="15">
          <el-col :md="6" size="small">
            <el-form-item label="Nume" prop="Nume">
              <el-input class="full-width" v-model="selectedObject.Nume" />
            </el-form-item>
          </el-col>
          <el-col :md="6" size="small">
            <el-form-item label="Centru productie" prop="IdCentruProductie">
              <el-select :disabled="this.mode == 'edit'" v-model="selectedObject.IdCentruProductie" class="full-width">
                <el-option v-for="item in Info.centre_productie" :key="'centre_productie' + item.Id" :label="item.Nume"
                  :value="item.Id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="6" size="small">
            <el-form-item label="Numar ordine" prop="OrderNo">
              <el-input-number class="full-width" :min="0" v-model="selectedObject.OrderNo" />
            </el-form-item>
          </el-col>
          <el-col :md="6" size="small">
            <el-form-item label="Pret" prop="Pret">
              <el-input-number :step="1" :precision="2" class="full-width" :min="0" v-model="selectedObject.Pret" />
            </el-form-item>
          </el-col>
          <el-col :md="6" size="small">
            <el-form-item label="Descriere" prop="Descriere">
              <el-input class="full-width" v-model="selectedObject.Descriere" />
            </el-form-item>
          </el-col>
          <el-col :md="6" size="small">
            <el-form-item label="Durata serviciu (secunde)" prop="DurataServiciu">
              <el-input-number class='full-width' v-model='selectedObject.DurataServiciu' :min="1" />
            </el-form-item>
          </el-col>
          <el-col :md="6" size="small">
            <el-form-item >
               <template #label>
                Include roti in inspectie
                <!-- adauga aici ce tooltip consideri corespunzator -->
                <el-tooltip content="" placement="top">
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </template>
              <el-select class="full-width" v-model="selectedObject.IncludeRoti" filterable>
                <el-option label="Da" value="1" />
                <el-option label="Nu" value="0" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="6" size="small">
            <el-form-item>
              <template #label>
                Forteaza 4 roti
                <el-tooltip content="Pentru serviciile care forteaza 4 roti, nu se mai completeaza antifurt, cuplu fata sau cuplu spate." placement="top">
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </template>
              <el-select class="full-width" v-model="selectedObject.CantitateStandard" filterable>
                <el-option label="Da" value="1" />
                <el-option label="Nu" value="0" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="15">
          <el-col :md="6" size="small">
            <el-form-item label="Iconita" prop="Iconita">
              <span>
                <img v-if="this.selectedObject.Iconita != ''"
                  style="width: 40px; height: 40px !important; margin-right:10px;" :src="this.selectedObject.Iconita" />
                
                  <el-upload
                    :action="baseUrl + '/servicii_programator/upload_iconita?id=' + selectedObject.Id"
                    :show-file-list="false"
                    name="imagine"
                    :on-success="handleIconitaSuccess">
                    <label class="btn btn-link">Schimba</label>
                  </el-upload>
              
              </span>
            </el-form-item>
          </el-col>

          <el-col :md="6" size="small">
            <el-form-item label="Obtine informatii aditionale">
              <el-select class="full-width" v-model="selectedObject.ObtineInformatiiAditionale" filterable>
                <el-option label="Da" value="1" />
                <el-option label="Nu" value="0" />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :md="6" size="small">
            <el-form-item>
              <template #label>
                Cuplu in inspectie
                <el-tooltip content="In inspectia finala, daca acest camp are valoarea 'Da' se va putea completa cuplul" placement="top">
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </template>
              <el-select class="full-width" v-model="selectedObject.CupluInInspectie" filterable>
                <el-option label="Da" value="1" />
                <el-option label="Nu" value="0" />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :md="6" size="small">
            <el-form-item>
              <template #label>
                Include ajutor montator
                <el-tooltip content="Daca acest camp are valoarea 'Da', se va putea alege ajutorul de montator in cadrul programarii." placement="top">
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </template>
              <el-select class="full-width" v-model="selectedObject.IncludeAjutorMontator" filterable>
                <el-option label="Da" value="1" />
                <el-option label="Nu" value="0" />
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row :gutter="15">

          <el-col :md="6" size="small">
            <el-form-item label="Optiune cantitate" prop="OptiuneCantitati">
              <el-select class="full-width" v-model="selectedObject.OptiuneCantitati">
                <el-option label="Fara cantitate" value="fara_cantitate" />
                <el-option label="Cantitate cu bifa hotel" value="cantitate_bifa_hotel" />
                <el-option label="Sursa si cantitate" value="sursa_destinatie" />
              </el-select>
            </el-form-item>
          </el-col>

          <!-- Cantitate cu bifa hotel -->
          <template v-if="selectedObject.OptiuneCantitati === 'cantitate_bifa_hotel'">
            <el-col :md="8" size="small">
              <el-form-item label="Text dialog cantitate simplu" prop="TextDialog">
                <el-input class="full-width" v-model="selectedObject.TextDialog" />
              </el-form-item>
              <span v-if="!selectedObject.TextDialog || selectedObject.TextDialog.length === 0" style="color: red;">
                Daca nu este completat, titlul dialogului pentru selectare cantitate nu va fi afisat.
              </span>
              <span v-else style="color: blue;">
                Va aparea in titlul dialogului pentru selectare cantitate.
              </span>
            </el-col>

            <el-col :md="8" size="small">
              <el-form-item label="Text bifa hotel din dialog cantitate simplu" prop="TextButonHotel">
                <el-input class="full-width" v-model="selectedObject.TextButonHotel" />
              </el-form-item>
              <span v-if="!selectedObject.TextButonHotel || selectedObject.TextButonHotel.length === 0"
                style="color: red;">
                Nu va aparea bifa pentru selectare roti Hotel
              </span>
              <span v-else style="color: blue;">
                Va aparea bifa pentru selectare roti Hotel cu label-ul introdus
              </span>
            </el-col>
          </template>

          <!-- Sursa si cantitate -->
          <template v-if="selectedObject.OptiuneCantitati === 'sursa_destinatie'">
            <el-col :md="6" size="small">
              <el-form-item label="Text dialog cantitate simplu" prop="TextDialog">
                <el-input class="full-width" v-model="selectedObject.TextDialog" />
              </el-form-item>
              <span v-if="!selectedObject.TextDialog || selectedObject.TextDialog.length === 0" style="color: red;">
                Daca nu este completat, titlul dialogului pentru selectare cantitate nu va fi afisat.
              </span>
              <span v-else style="color: blue;">
                Va aparea in titlul dialogului pentru selectare cantitate.
              </span>
            </el-col>
            <el-col :md="6" size="small">
              <el-form-item label="Text card sursa" prop="TitluSursa">
                <el-input class="full-width" v-model="selectedObject.TitluSursa" />
              </el-form-item>
              <span v-if="!selectedObject.TitluSursa || selectedObject.TitluSursa.length === 0" style="color: red;">
                Daca nu este completat, titlul card-ului pentru selectare cantitate sursa nu va fi afisat.
              </span>
              <span v-else style="color: blue;">
                Va aparea in titlul card-ului pentru selectare cantitate sursa.
              </span>
            </el-col>

            <el-col :md="6" size="small">
              <el-form-item label="Text card destinatie" prop="TitluDestinatie">
                <el-input class="full-width" v-model="selectedObject.TitluDestinatie" />
              </el-form-item>
              <span v-if="!selectedObject.TitluDestinatie || selectedObject.TitluDestinatie.length === 0"
                style="color: red;">
                Daca nu este completat, titlul card-ului pentru selectare cantitate destinatie nu va fi afisat.
              </span>
              <span v-else style="color: blue;">
                Va aparea in titlul card-ului pentru selectare cantitate destinatie.
              </span>
            </el-col>

            <el-col :md="8" size="small">
              <el-form-item label="Label sursa hotel" prop="LabelSursaHotel">
                <el-input class="full-width" v-model="selectedObject.LabelSursaHotel" />
              </el-form-item>
              <span v-if="!selectedObject.LabelSursaHotel || selectedObject.LabelSursaHotel.length === 0"
                style="color: red;">
                Daca nu este completat, label-ul pentru cantitatea sursa hotel nu va fi afisat.
              </span>
              <span v-else style="color: blue;">
                Va aparea ca label pentru cantitatea sursa hotel.
              </span>
            </el-col>

            <el-col :md="8" size="small">
              <el-form-item label="Label sursa personal" prop="LabelSursaPersonal">
                <el-input class="full-width" v-model="selectedObject.LabelSursaPersonal" />
              </el-form-item>
              <span v-if="!selectedObject.LabelSursaPersonal || selectedObject.LabelSursaPersonal.length === 0"
                style="color: red;">
                Daca nu este completat, label-ul pentru cantitatea sursa personal nu va fi afisat.
              </span>
              <span v-else style="color: blue;">
                Va aparea ca label pentru cantitatea sursa personal.
              </span>
            </el-col>

            <el-col :md="8" size="small">
              <el-form-item label="Label sursa comanda" prop="LabelSursaComanda">
                <el-input class="full-width" v-model="selectedObject.LabelSursaComanda" />
              </el-form-item>
              <span v-if="!selectedObject.LabelSursaComanda || selectedObject.LabelSursaComanda.length === 0"
                style="color: red;">
                Daca nu este completat, label-ul pentru cantitatea sursa comanda nu va fi afisat.
              </span>
              <span v-else style="color: blue;">
                Va aparea ca label pentru cantitatea sursa comanda.
              </span>
            </el-col>

            <el-col :md="8" size="small">
              <el-form-item label="Label destinatie reciclare" prop="LabelDestinatieReciclare">
                <el-input class="full-width" v-model="selectedObject.LabelDestinatieReciclare" />
              </el-form-item>
              <span
                v-if="!selectedObject.LabelDestinatieReciclare || selectedObject.LabelDestinatieReciclare.length === 0"
                style="color: red;">
                Daca nu este completat, label-ul pentru cantitatea destinatie reciclare nu va fi afisat.
              </span>
              <span v-else style="color: blue;">
                Va aparea ca label pentru cantitatea destinatie reciclare.
              </span>
            </el-col>

            <el-col :md="8" size="small">
              <el-form-item label="Label destinatie hotel" prop="LabelDestinatieHotel">
                <el-input class="full-width" v-model="selectedObject.LabelDestinatieHotel" />
              </el-form-item>
              <span v-if="!selectedObject.LabelDestinatieHotel || selectedObject.LabelDestinatieHotel.length === 0"
                style="color: red;">
                Daca nu este completat, label-ul pentru cantitatea destinatie hotel nu va fi afisat.
              </span>
              <span v-else style="color: blue;">
                Va aparea ca label pentru cantitatea destinatie hotel.
              </span>
            </el-col>

            <el-col :md="8" size="small">
              <el-form-item label="Label destinatie returnare" prop="LabelDestinatieReturnare">
                <el-input class="full-width" v-model="selectedObject.LabelDestinatieReturnare" />
              </el-form-item>
              <span
                v-if="!selectedObject.LabelDestinatieReturnare || selectedObject.LabelDestinatieReturnare.length === 0"
                style="color: red;">
                Daca nu este completat, label-ul pentru cantitatea destinatie returnare nu va fi afisat.
              </span>
              <span v-else style="color: blue;">
                Va aparea ca label pentru cantitatea destinatie returnare.
              </span>
            </el-col>
          </template>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showPopup = false"> Renunta </el-button>
        <el-button type="primary" @click="save"> Salveaza </el-button>
      </span>
      <!-- {{this.selectedObject}} -->
    </div>
  </el-dialog>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";


export default {
  name: "Servicii_programator_dialog",
  extends: BasePage,
  data() {



    // let validateTextButonHotel = async (rule, value, callback) => {
    //   console.log('apelat')
    //   console.log("this.selectedObject.FaraOptiuneHotel",this.selectedObject)
    //   if (this.selectedObject.FaraOptiuneHotel != 1 && value =="") {
    //     // return
    //     console.log('dsds')
    //     callback();
    //   } else {
    //     callback(new Error("Email-ul introdus nu este unul valid"))
    //   }
    // }

    return {
      imageUrl: "",
      baseUrl: "",
      showPopup: false,
      titlu: "",
      mode: "add",
      image: '',
      selectedObject: {
        Nume: "",
        IdCentruProductie: "",
        Pret: "",
        Descriere: "",
        DurataServiciu: "",
        TextDialog: "",
        TextButonHotel: "",
        Iconita: "",
        OrderNo: "",
        // FaraOptiuneHotel: "0",
        TitluSursa: "",
        TitluDestinatie: "",
        OptiuneCantitati: "fara_cantitate",
      },
      Info: {
        centre_productie: [],
      },
      rules: {
        Nume: [{ required: true, message: "Campul este obligatoriu" }],
        IdCentruProductie: [{ required: true, message: "Campul este obligatoriu" }],
        OrderNo: [{ required: true, message: "Campul este obligatoriu" }],
        Iconita: [{ required: true, message: "Campul este obligatoriu" }],
        DurataServiciu: [{ required: true, message: "Campul este obligatoriu" }],
        Descriere: [{ required: true, message: "Campul este obligatoriu" }],
        TextDialog: [{ required: false, message: "Campul este obligatoriu" }],
        TextButonHotel: [{ required: false, message: "Campul este obligatoriu" }],
        OptiuneCantitati: [{ required: true, message: "Campul este obligatoriu" }],
        // TextButonHotel: [{ required: false, validator: validateTextButonHotel }],
      },
    };
  },
  methods: {
    show_me: async function (id) {
      this.showPopup = true;
      if (id == null) {
        this.mode = "add";
        this.titlu = "Adauga un serviciu pentru programator";
        this.selectedObject = { Nume: "", IdCentruProductie: "", Iconita: "", OrderNo: "", TextButonHotel: "", TextDialog: "" }
      } else {
        this.mode = "edit";
        this.titlu = "Editeaza serviciu programator";
        var result = await this.post("servicii_programator/get_info_item_dialog", {
          id: id,
        });
        this.selectedObject = result.Item;
      }
      this.selectedObject.DurataInitiala = this.selectedObject.DurataServiciu;
    },
    async get_info() {
      var response = await this.post("servicii_programator/get_info_for_dialog");
      this.Info.centre_productie = response.centre_productie;
    },

    async save() {
      await this.$refs["my-form"].validate(async (valid) => {
        if (valid) {
          // console.log(this.selectedObject.DurataInitiala == this.selectedObject.DurataServiciu)
          // console.log(this.selectedObject.DurataInitiala , this.selectedObject.DurataServiciu)
          if (this.selectedObject.DurataInitiala == this.selectedObject.DurataServiciu || this.mode == 'add') {
            await this.post("servicii_programator/save", { mode: this.mode, object: this.selectedObject, durataInitiala: this.selectedObject.DurataInitiala });
            this.showPopup = false;
            this.$emit("save");
          } else {
            if (this.selectedObject.DurataInitiala > this.selectedObject.DurataServiciu) {
              var textDialog = 'A fost miscorata durata acestui serviciu. Toate programarile incepand de maine vor fi modificate cu durata noua. Sunteti sigur?';
            } else {
              var textDialog = 'A fost marita durata acestui serviciu. Toate programarile incepand de maine vor fi modificate cu durata noua. Unele programari se pot suprapune. Sunteti sigur?';
            }

            this.$confirm(textDialog, 'Atentie!', {
              type: 'warning',
              cancelButtonText: 'Anuleaza',
            }).then(async () => {
              let res = await this.post("servicii_programator/save", { mode: this.mode, object: this.selectedObject, durataInitiala: this.selectedObject.DurataInitiala });

              // this.refresh_info(); 
              this.$message({ type: 'success', message: 'Modificarea a fost salvata. Au fost modificate ' + res.programari_modificate + ' programari!' });
              this.showPopup = false;
              this.$emit("save");
            }).catch(() => {
              this.$message({ type: 'info', message: 'Modificare anulata' });
            });

          }

        }
      })
    },



    handleIconitaSuccess(res){
      this.selectedObject.Iconita = res;
    }


    // onFileChange(e) {
    //   var files = e.target.files || e.dataTransfer.files;
    //   if (!files.length)
    //     return;
    //   this.createImage(files[0]);
    //   this.selectedObject.Iconita = this.image

    // },
    // createImage(file) {
    //   var image = new Image();
    //   var reader = new FileReader();
    //   var vm = this;

    //   reader.onload = (e) => {
    //     // vm.image = e.target.result;
    //     vm.selectedObject.Iconita = e.target.result;
    //   };
    //   reader.readAsDataURL(file);

    // },



  },
  watch: {
    'selectedObject.OptiuneCantitati'(newVal) {
      if (newVal === 'fara_cantitate') {
        this.selectedObject.TextDialog = null;
        this.selectedObject.TextButonHotel = null;
        this.selectedObject.TitluSursa = null;
        this.selectedObject.TitluDestinatie = null;
      } else if (newVal === 'cantitate_bifa_hotel') {
        this.selectedObject.TitluSursa = null;
        this.selectedObject.TitluDestinatie = null;
      } else if (newVal === 'sursa_destinatie') {
        this.selectedObject.TextButonHotel = null;
      }
    }
  },
  mounted: function () {
    this.baseUrl = settings.BASE_URL;
    this.get_info();
  },
};
</script>

<style lang="less">
#popup_dialog {
  .full-width {
    width: 100% !important;
  }

  .container {
    width: 100% !important;
  }

  @media only screen and (max-width: 600px) {
    .el-dialog {
      min-width: 90vw !important;
    }
  }
}
</style>